export const DEFAULT_SPRING_CONFIG = {
  mass: 1,
  tension: 500,
  friction: 30,
}
